import React from "react";
import styled from 'styled-components';
const StyledFrameFooter = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  @media only screen and (min-width: 768px) {
      justify-content: ${props => props.align === "left" ? "left" : "center"};
  }
`;
const FrameFooter = ({ className, children, align }) => (React.createElement(StyledFrameFooter, { className: className, align: align }, children));
export default FrameFooter;
